import React from 'react';
import PropTypes from 'prop-types';

const BUCKETS = [
  {
    key: 'engagement',
    label: 'Engagement',
    sublabel: 'Social',
    sources: ['tweet', 'fbwall', 'rdt', 'bluesky'],
    color: '#42A5F5'
  },
  {
    key: 'reach',
    label: 'Reach',
    sublabel: 'Media',
    sources: ['msm', 'blog', 'wikipedia'],
    color: '#e53935'
  },
  {
    key: 'impact',
    label: 'Impact',
    sublabel: 'Policy / Patents / Guidelines',
    sources: ['policy', 'patent', 'guideline'],
    color: '#673AB7'
  }
];

const CurrentsMetricsList = ({ mentionCounts }) => {
  if (!mentionCounts) return null;

  const rows = BUCKETS.map((b) => ({
    ...b,
    count: b.sources.reduce((sum, s) => sum + (mentionCounts[s] || 0), 0)
  }));

  const total = rows.reduce((sum, r) => sum + r.count, 0);
  if (total === 0) return null;

  const dominantKey = rows.reduce((max, r) => (r.count > max.count ? r : max), rows[0]).key;

  return (
    <div className="CurrentsCard-metrics" aria-label="Mention type breakdown">
      {rows.map((row) => {
        const pct = Math.round((row.count / total) * 100);
        const isDominant = row.key === dominantKey && row.count > 0;
        return (
          <div
            key={row.key}
            className={`CurrentsCard-metric${isDominant ? ' is-dominant' : ''}`}
            title={`${row.label} (${row.sublabel}): ${row.count.toLocaleString()} mentions, ${pct}% of total`}
          >
            <span className="CurrentsCard-metric-swatch" style={{ background: row.color }} aria-hidden="true" />
            <span className="CurrentsCard-metric-label">{row.label}</span>
            <span className="CurrentsCard-metric-count">{row.count.toLocaleString()}</span>
            <span className="CurrentsCard-metric-pct">{pct}%</span>
          </div>
        );
      })}
    </div>
  );
};

CurrentsMetricsList.propTypes = {
  mentionCounts: PropTypes.object
};

export default CurrentsMetricsList;
